import { render, staticRenderFns } from "./MergeProductsModal.vue?vue&type=template&id=70343368"
import script from "./MergeProductsModal.vue?vue&type=script&lang=js"
export * from "./MergeProductsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports